module.exports = __webpack_public_path__ + "static/media/filled_bar_prewash10_tall.5f44dcab.svg";